// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrdersHistory_wrapper__2zQvI","rowTable":"OrdersHistory_rowTable__2e1zU"};